import {Component, OnInit} from '@angular/core';
import {MasterSlaveStatus, MonitoredService, ServiceStatus} from '../../../../../types/stolcher-types';
import { PanelModule } from 'primeng/panel';
import { PrimeTemplate } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { BadgeModule } from 'primeng/badge';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { MessageModule } from 'primeng/message';
import {MessageComponent, MessageSeverity} from '../../message/message.component';
import {TargetBlankDirective} from '../../../directives/target-blank.directive';
import {PagePanelComponent} from '../../panels/page-panel/page-panel.component';

const VERSION = 1;
const MAX_NUMBER_OF_RELOADS = 10;

@Component({
    selector: 'app-monitored-services',
    templateUrl: './monitored-services.component.html',
    styleUrls: ['./monitored-services.component.scss'],
    imports: [PanelModule, PrimeTemplate, BadgeModule, TableModule, TagModule, MessageModule, DatePipe, MessageComponent, TargetBlankDirective, PagePanelComponent]
})
export class MonitoredServicesComponent implements OnInit {

    stolcherInstances: MasterSlaveStatus[] = [];
    services: MonitoredService[] = [];
    servicesStatus: ServiceStatus[] = [];

    service(s: MonitoredService) {
        return s;
    }

    constructor() {
    }

    ngOnInit(): void {
        this.refresh();
    }

    async loadStolcherInstances() {
        this.stolcherInstances = await window.stolcherClient.getOnlineMastersAndSlaves(VERSION);
    }

    async loadStolcherServices() {
        this.services = await window.stolcherClient.getServicesList(VERSION);
    }

    async loadStolcherServicesStatus() {
        this.servicesStatus = await window.stolcherClient.getServicesStatus(VERSION);
    }

    async refresh() {
        if (window.stolcherClient) {
            // controlla se lo script è stato caricato
            await this.loadStolcherInstances();
            await this.loadStolcherServicesStatus();
            await this.loadStolcherServices();

            this.services.sort((a, b) => {
                const aSeverity = this.serviceStatusSeverityToInt(a);
                const bSeverity = this.serviceStatusSeverityToInt(b);
                return bSeverity - aSeverity;
            });

            setTimeout(() => this.refresh(), 1000 * 60);
        }
    }

    private serviceStatusSeverityToInt(service: MonitoredService) {
        const status = this.serviceStatus(service);
        if (status.toLowerCase() === 'online') {
            return 0;
        }
        if (status.toLowerCase() === 'offline') {
            return 2;
        }
        return 1;
    }

    serviceStatus(service: MonitoredService) {
        return this.servicesStatus.find(s => s.monitoredServiceName === service.monitoredServiceName)?.status ?? 'WARNING';
    }

    serviceStatusSeverity(service: MonitoredService) {
        const status = this.serviceStatus(service);
        if (status.toLowerCase() === 'online') {
            return 'success';
        }
        if (status.toLowerCase() === 'offline') {
            return 'danger';
        }
        return 'warn';
    }

    serviceStatusSeverityForMessage(service: MonitoredService): MessageSeverity {
        const status = this.serviceStatus(service);
        if (status.toLowerCase() === 'online') {
            return 'success';
        }
        if (status.toLowerCase() === 'offline') {
            return 'error';
        }
        return 'warning';
    }

    serviceLastUpdate(service: MonitoredService) {
        return this.servicesStatus.find(s => s.monitoredServiceName === service.monitoredServiceName)?.lastCheckedAt;
    }

    protected serviceStatusDetails(service: MonitoredService) {
        const status = this.servicesStatus.find(s => s.monitoredServiceName === service.monitoredServiceName);
        if (status) {
            return status.statusMessage;
        }
        return 'Non è disponibile lo stato di questo servizio';
    }

    protected serviceStatusNotes(service: MonitoredService) {
        const status = this.servicesStatus.find(s => s.monitoredServiceName === service.monitoredServiceName);
        if (status) {
            return status.notes;
        }
        return 'Non è disponibile lo stato di questo servizio';
    }
}
